import { TERMS_VERSION } from "@brandwall/contracts";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ApiError, post } from "../api";

/** Shown once to people who haven't accepted the current terms, e.g. after Google sign-up. */
export function AcceptTerms() {
  const qc = useQueryClient();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const accept = async () => {
    setBusy(true);
    setError(null);
    try {
      await post("/v1/me/accept-terms", { version: TERMS_VERSION });
      await qc.invalidateQueries({ queryKey: ["me"] });
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Something went wrong. Please try again.");
      setBusy(false);
    }
  };
  return (
    <div className="onb">
      <div className="box stack">
        <img className="logo" src="/logo.svg" alt="Brandwall" />
        <h1>Before you start</h1>
        <p className="muted">
          Please accept Brandwall's terms. They explain, among other things, that your business
          decides which posts it shows and is responsible for getting the permission it needs.
        </p>
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        <label className="row small" style={{ alignItems: "flex-start", gap: 8 }}>
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ marginTop: 3 }}
          />
          <span>
            I accept the{" "}
            <a href="/terms" target="_blank" rel="noreferrer">
              terms
            </a>{" "}
            for my business, and I've read the{" "}
            <a href="/privacy" target="_blank" rel="noreferrer">
              privacy policy
            </a>
            .
          </span>
        </label>
        <button type="button" className="btn block" disabled={!checked || busy} onClick={accept}>
          {busy ? "One moment…" : "Continue"}
        </button>
      </div>
    </div>
  );
}
